import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PorchOrDeckProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PorchOrDeck: React.FC<PorchOrDeckProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [porchOrDeck, set_porchOrDeck] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Porch or Deck']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Porch or Deck': [b.values?.['Exterior Structure']?.['Porch or Deck']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Porch or Deck';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(porchOrDeck)}
                />
            ) : (
                <MoneyBox
                    id={'porchOrDeck'}
                    allowNegative={false}
                    value={porchOrDeck}
                    onChange={(value) => set_porchOrDeck(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
